"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _orderInfo = require("@/api/order/orderInfo");
var _region = require("@/api/basic/region");
var _goods = require("@/api/goods/goods");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var payStatusOptions = [{
  key: 0,
  value: '未付款'
}, {
  key: 1,
  value: '付款中'
}, {
  key: 2,
  value: '已付款'
}];
var payStatusKeyValue = payStatusOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var shippingStatusOptions = [{
  key: 0,
  value: '未发货'
}, {
  key: 1,
  value: '已发货'
}, {
  key: 2,
  value: '收货确认'
}, {
  key: 3,
  value: '备货中'
}, {
  key: 4,
  value: '部分发货'
}, {
  key: 5,
  value: '发货中（处理分单）'
}, {
  key: 6,
  value: '已选仓'
}];
var shippingStatusKeyValue = shippingStatusOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var orderStatusOptions = [{
  key: 0,
  value: '未确认'
}, {
  key: 1,
  value: '已确认'
}, {
  key: 2,
  value: '已取消'
}, {
  key: 3,
  value: '无效'
}, {
  key: 4,
  value: '退货'
}, {
  key: 5,
  value: '已分单'
}, {
  key: 6,
  value: '部分分单'
}, {
  key: 7,
  value: '已完结'
}];
var orderStatusKeyValue = orderStatusOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var dealTypeOptions = [{
  key: 1,
  value: '代金券'
}, {
  key: 2,
  value: '商品券'
}];
var dealTypeKeyValue = dealTypeOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var _default = exports.default = {
  name: 'orderDetail',
  props: {
    orderId: {
      type: [Number, String],
      default: null
    },
    type: {
      type: String,
      default: 'edit'
    }
  },
  filters: {
    payStatusFilter: function payStatusFilter(key) {
      return payStatusKeyValue[key];
    },
    orderStatusFilter: function orderStatusFilter(key) {
      return orderStatusKeyValue[key];
    },
    shippingStatusFilter: function shippingStatusFilter(key) {
      return shippingStatusKeyValue[key];
    },
    dealTypeFilter: function dealTypeFilter(key) {
      return dealTypeKeyValue[key];
    }
  },
  data: function data() {
    return {
      orderData: {
        user: {},
        userExtInfo: {},
        deliveryOrder: {}
      },
      resPath: process.env.VUE_IMAGE_PATH,
      remark: null,
      receiverVisible: false,
      receiverForm: {},
      countryList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      feeVisible: false,
      feeForm: {},
      itemAddVisible: false,
      itemAddForm: {
        goodsId: null,
        unitId: null
      },
      goodsList: [],
      isEditingPayNote: false,
      editPayNote: ''
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    // 计算实付价总和
    getSummaryMethod: function getSummaryMethod(param) {
      var columns = param.columns,
        data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '';
        } else if (index === 7) {
          // 做法列显示"合计："
          sums[index] = '合计：';
        } else if (index === 8) {
          // 实付价列计算总和
          var prices = data.filter(function (item) {
            return item.goodsPrice;
          });
          var sum = prices.reduce(function (total, item) {
            return total + parseFloat(item.goodsPrice || 0);
          }, 0);
          sums[index] = sum.toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    handleGoodsChange: function handleGoodsChange() {
      console.log(this.itemAddForm.goodsId);
    },
    handleSearchGoods: function handleSearchGoods(query) {
      var _this = this;
      (0, _goods.queryList)({
        keywords: query
      }).then(function (res) {
        _this.goodsList = res.records;
      });
    },
    handleAddGoods: function handleAddGoods() {
      this.itemAddVisible = true;
    },
    handleFeeUpdate: function handleFeeUpdate() {
      var _this2 = this;
      (0, _orderInfo.update)(this.feeForm).then(function (res) {
        _this2.$message.success('操作成功');
        _this2.feeVisible = false;
        _this2.init();
      });
    },
    handleFeeEdit: function handleFeeEdit() {
      this.feeForm = {
        orderId: this.orderData.orderId,
        payFee: this.orderData.payFee,
        surplus: this.orderData.surplus,
        integral: this.orderData.integral,
        discount: this.orderData.discount
      };
      this.feeVisible = true;
    },
    handleReceiverUpdate: function handleReceiverUpdate() {
      var _this3 = this;
      (0, _orderInfo.update)(this.receiverForm).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.receiverVisible = false;
        _this3.init();
      });
    },
    handleRegionChange: function handleRegionChange(val, type) {
      var _this4 = this;
      if (!val) {
        return;
      }
      this.getRegionList(val).then(function (res) {
        if ('country' === type) {
          _this4.provinceList = res;
        } else if ('province' === type) {
          _this4.cityList = res;
        } else if ('city' === type) {
          _this4.districtList = res;
        }
      });
    },
    getRegionList: function () {
      var _getRegionList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(parentId) {
        var query, res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = {
                page: 1,
                limit: 1000,
                parentId: parentId
              };
              _context.next = 1;
              return (0, _region.queryPage)(query);
            case 1:
              res = _context.sent;
              return _context.abrupt("return", res.records);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getRegionList(_x) {
        return _getRegionList.apply(this, arguments);
      }
      return getRegionList;
    }(),
    handleReceiverEdit: function handleReceiverEdit() {
      this.receiverForm = {
        orderId: this.orderData.orderId,
        consignee: this.orderData.consignee,
        mobile: this.orderData.mobile,
        country: this.orderData.country,
        province: this.orderData.province,
        city: this.orderData.city,
        district: this.orderData.district,
        address: this.orderData.address
      };
      this.receiverVisible = true;
      if (this.receiverForm.country) {
        this.handleRegionChange(this.receiverForm.country, 'country');
      }
      if (this.receiverForm.province) {
        this.handleRegionChange(this.receiverForm.province, 'province');
      }
      if (this.receiverForm.city) {
        this.handleRegionChange(this.receiverForm.city, 'city');
      }
    },
    handleAction: function handleAction(action) {
      var _this5 = this;
      this.$confirm('确定修改吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          orderId: _this5.orderId
        };
        if ('cancel' === action) {
          (0, _orderInfo.cancelOrder)(data).then(function (res) {});
        } else if ('pay' === action) {
          (0, _orderInfo.pay)(data).then(function (res) {});
        } else if ('createShipmentOrder' === action) {
          (0, _orderInfo.createShipmentOrder)(data).then(function (res) {});
        } else if ('shipment' === action) {
          (0, _orderInfo.shipment)(data).then(function (res) {});
        } else if ('receipt' === action) {
          (0, _orderInfo.receipt)(data).then(function (res) {});
        }
        _this5.$message.success('操作成功');
        _this5.init();
      }).catch(function () {});
    },
    handleRemark: function handleRemark() {
      var _this6 = this;
      this.$confirm('确定添加备注吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _orderInfo.addOrderAction)({
          orderId: _this6.orderId,
          actionNote: _this6.remark
        }).then(function (res) {
          _this6.$message.success('添加成功');
          _this6.init();
        });
      }).catch(function () {});
    },
    init: function () {
      var _init = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this7 = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              (0, _orderInfo.getById)(this.orderId).then(function (res) {
                var data = res.data || {};
                // 后端某些订单 userExtInfo 可能为 null，兜底避免模板读取 payPoints 等字段时报错导致整页渲染失败
                _this7.orderData = _objectSpread(_objectSpread({}, data), {}, {
                  userExtInfo: data.userExtInfo || {}
                });
              });
              this.getRegionList(0).then(function (res) {
                _this7.countryList = res;
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    handleViewGoods: function handleViewGoods(row) {
      this.$router.push({
        path: '/goods/goodsLibrary',
        query: {
          keywords: row.goodsName
        }
      });
    },
    handleViewMember: function handleViewMember(mobilePhone) {
      this.$router.push({
        path: '/member/memberManagement',
        query: {
          mobilePhone: mobilePhone
        }
      });
    },
    handlePayNoteEdit: function handlePayNoteEdit() {
      var _this8 = this;
      this.isEditingPayNote = true;
      this.editPayNote = this.orderData.payNote || '';
      this.$nextTick(function () {
        _this8.$refs.payNoteInput.focus();
      });
    },
    handlePayNoteBlur: function handlePayNoteBlur() {
      this.savePayNote();
    },
    handlePayNoteEnter: function handlePayNoteEnter() {
      this.savePayNote();
    },
    savePayNote: function savePayNote() {
      var _this9 = this;
      if (!this.isEditingPayNote) return;
      this.isEditingPayNote = false;
      var newPayNote = this.editPayNote.trim();

      // 如果备注没有变化，不保存
      if (newPayNote === (this.orderData.payNote || '')) {
        return;
      }

      // 调用后端接口保存备注
      (0, _orderInfo.updatePayNote)({
        orderId: this.orderId,
        payNote: newPayNote
      }).then(function (res) {
        _this9.$message.success('保存成功');
        _this9.orderData.payNote = newPayNote;
      }).catch(function () {
        _this9.$message.error('保存失败');
      });
    },
    // 格式化套餐信息
    formatSuitInfo: function formatSuitInfo(row) {
      if (!row.suitInfo) return '';
      try {
        var suitData = typeof row.suitInfo === 'string' ? JSON.parse(row.suitInfo) : row.suitInfo;
        if (!Array.isArray(suitData)) return '';

        // 先尝试原逻辑：嵌套分组结构
        try {
          var _result = [];
          suitData.forEach(function (group) {
            if (group.goods && Array.isArray(group.goods)) {
              group.goods.forEach(function (item) {
                var text = "<span>".concat(item.goodsName, "</span>");

                // 数量
                if (item.goodsNumber) {
                  text += "<span style=\"margin-left: 8px;\">x ".concat(item.goodsNumber, "</span>");
                }

                // 单位
                if (item.unitName) {
                  text += "<span style=\"margin-left: 4px;\">".concat(item.unitName, "</span>");
                }

                // 价格
                if (item.price) {
                  text += "<span style=\"margin-left: 8px;\">/ ".concat(parseFloat(item.price).toFixed(2), "</span>");
                }

                // 收集所有做法
                var methods = [];

                // 加价显示
                if (item.addPrice && parseFloat(item.addPrice) > 0) {
                  methods.push('¥+' + parseFloat(item.addPrice).toFixed(2));
                }

                // 添加做法类型
                if (item.goodsMakeMethods && Array.isArray(item.goodsMakeMethods)) {
                  item.goodsMakeMethods.forEach(function (method) {
                    if (method.methodName) {
                      var methodText = method.methodName;
                      // 如果做法有价格，追加价格
                      if (method.methodPrice && parseFloat(method.methodPrice) > 0) {
                        methodText += ' ¥+' + parseFloat(method.methodPrice).toFixed(2);
                      }
                      methods.push(methodText);
                    }
                  });
                }

                // 如果有做法，添加到后面
                if (methods.length > 0) {
                  text += "<span style=\"margin-left: 8px;\">".concat(methods.join('/'), "</span>");
                }
                _result.push(text);
              });
            }
          });
          if (_result.length > 0) {
            return _result.join('<br>');
          }
        } catch (innerError) {
          console.log('原逻辑解析失败，尝试新逻辑:', innerError);
        }

        // 如果原逻辑失败，尝试新逻辑：扁平化数组结构
        var result = [];
        suitData.forEach(function (item) {
          var text = "<span>".concat(item.goods_name || item.goodsName, "</span>");

          // 数量
          if (item.goods_number || item.goodsNumber) {
            text += "<span style=\"margin-left: 8px;\">x ".concat(item.goods_number || item.goodsNumber, "</span>");
          }

          // 单位
          if (item.unit_name || item.unitName) {
            text += "<span style=\"margin-left: 4px;\">".concat(item.unit_name || item.unitName, "</span>");
          }

          // 价格
          if (item.price) {
            text += "<span style=\"margin-left: 8px;\">/ \xA5".concat(parseFloat(item.price).toFixed(2), "</span>");
          }

          // 收集所有做法
          var methods = [];

          // 加价显示
          if (item.add_price && parseFloat(item.add_price) > 0) {
            methods.push('¥+' + parseFloat(item.add_price).toFixed(2));
          } else if (item.addPrice && parseFloat(item.addPrice) > 0) {
            methods.push('¥+' + parseFloat(item.addPrice).toFixed(2));
          }

          // 添加做法类型
          var makeMethods = item.goods_make_method || item.goodsMakeMethod || [];
          if (Array.isArray(makeMethods) && makeMethods.length > 0) {
            makeMethods.forEach(function (method) {
              if (method.method_name || method.methodName) {
                var methodText = method.method_name || method.methodName;
                // 如果做法有价格，追加价格
                if (method.method_price && parseFloat(method.method_price) > 0) {
                  methodText += ' ¥+' + parseFloat(method.method_price).toFixed(2);
                } else if (method.methodPrice && parseFloat(method.methodPrice) > 0) {
                  methodText += ' ¥+' + parseFloat(method.methodPrice).toFixed(2);
                }
                methods.push(methodText);
              }
            });
          }

          // 如果有做法，添加到后面
          if (methods.length > 0) {
            text += "<span style=\"margin-left: 8px;\">".concat(methods.join('/'), "</span>");
          }
          result.push(text);
        });
        return result.join('<br>');
      } catch (e) {
        console.error('解析suitInfo失败:', e);
        return '';
      }
    },
    // 格式化非套餐商品信息
    formatNonSuitInfo: function formatNonSuitInfo(row) {
      var parts = [];

      // 如果有unitName，添加单位
      if (row.unitName) {
        parts.push(row.unitName);
      }

      // 如果有goodsMakeMethod，解析并拼接method_name
      if (row.goodsMakeMethod) {
        try {
          var makeMethods = typeof row.goodsMakeMethod === 'string' ? JSON.parse(row.goodsMakeMethod) : row.goodsMakeMethod;
          if (Array.isArray(makeMethods) && makeMethods.length > 0) {
            var methodNames = makeMethods.map(function (method) {
              return method.method_name || method.methodName;
            }).filter(function (name) {
              return name;
            });
            if (methodNames.length > 0) {
              parts.push(methodNames.join('/'));
            }
          }
        } catch (e) {
          console.error('解析goodsMakeMethod失败:', e);
        }
      }
      return parts.join(',');
    }
  }
};